// Constants
import { DRAG_START, DRAG_END, REPLACE_MODE_START, REPLACE_MODE_END } from './draggingConstants';

export const dragStart = (
    {
        ids,
        source,
        elementType,
        finishEditing = true,
    }: {
        ids?: string[];
        source?: string;
        /** The type of element being created, for creation-tool drags that have no ids yet */
        elementType?: string;
        finishEditing?: boolean;
    } = {
        ids: undefined,
        source: undefined,
        elementType: undefined,
        finishEditing: true,
    },
) => ({
    type: DRAG_START,
    ids,
    source,
    elementType,
    finishEditing,
});

type DropState = {
    // TODO: flesh this out with valid values
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
};

export const dragEnd = (dropState: DropState) => ({ type: DRAG_END, dropState });
export const startReplaceMode = (elementId: string) => ({ type: REPLACE_MODE_START, elementId });
export const endReplaceMode = () => ({ type: REPLACE_MODE_END });
